import {
    Card,
    CardContent,
    Grid,
    Box,
    Button,
    Stack,
    CircularProgress,
} from "@mui/material";
import Tabs from "../../../branchDepartment/components/tabs";
import { useState, useEffect } from "react";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../../../config/appRoutes";
import { addTagThunk, getTagsThunk } from '../../../contact/contactThunk';
import { FieldTextField } from "../../../../components/selections/fieldInputs";
import { stepCardSx, stepActionsSx, nextBtnSx, backBtnSx, StepHeader } from "../../../campaign/components/stepUi";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import NewLabelOutlinedIcon from "@mui/icons-material/NewLabelOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// Create-tag form. `embedded` = inside the list page popup (no page header, Cancel button,
// onSuccess(message) closes the popup and the list shows the message).
export function TagCreateForm({ embedded = false, onCancel, onSuccess }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { status, error } = useSelector((state) => state.contacts);
    const [tagName, setTagName] = useState("");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!tagName.trim()) {
            setSnackbar({
                open: true,
                message: "Tag Name is required",
                severity: "error",
            });
            return;
        }
        try {
             const result = await dispatch(
                addTagThunk({ credentials: { tag_name: tagName.trim() } })
            );

            if (result.meta.requestStatus === "fulfilled") {
                if (onSuccess) {
                    dispatch(getTagsThunk({ type: "tags" }));
                    onSuccess(result.payload?.message);
                    return;
                }
                setSnackbar({
                    open: true,
                    message: result.payload.message,
                    severity: "success",
                });
                dispatch(getTagsThunk({ type: "tags" }));
                navigate(APP_ROUTES.TAGS.LIST);
            } else {
                setSnackbar({
                    open: true,
                    message: result.payload,
                    severity: "error",
                });
            }
        } catch {
            setSnackbar({
                open: true,
                message: "Server error. Please try again.",
                severity: "error",
            });
        }
    };

    useEffect(() => {
        if (error !== null) {
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    }, [error]);

    const Wrap = embedded ? Box : Tabs;

    return (
        <div>
            <Wrap>
                <Box mt={embedded ? 0 : 1}>
                    <Card elevation={0} sx={embedded ? { borderRadius: 0, boxShadow: "none" } : stepCardSx}>
                        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                            {!embedded && (
                                <StepHeader
                                    icon={<NewLabelOutlinedIcon sx={{ fontSize: 20 }} />}
                                    title="Create Tag"
                                    subtitle="Add a new tag for your contacts"
                                />
                            )}
                            <Grid container spacing={2}>
                                <Grid item size={embedded ? { xs: 12 } : { xs: 12, sm: 8, md: 5 }}>
                                    <FieldTextField
                                        name="tagName"
                                        label="Tag Name"
                                        placeholder="Enter tag name"
                                        required
                                        icon={<LocalOfferOutlinedIcon />}
                                        value={tagName}
                                        maxLength={20}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.startsWith(" ")) return;
                                            setTagName(value);
                                        }}
                                        error={!tagName.trim() && snackbar.severity === "error"}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>

                        {/* Footer actions */}
                        <Box sx={stepActionsSx}>
                            <Stack direction="row" spacing={1.5}>
                                {embedded && (
                                    <Button onClick={onCancel} sx={backBtnSx}>Cancel</Button>
                                )}
                                <Button
                                    disabled={status === "loading"}
                                    onClick={status === "loading" ? null : handleSubmit}
                                    startIcon={status === "loading" ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : <AddCircleOutlineIcon />}
                                    sx={nextBtnSx}
                                >
                                    {status === "loading" ? "Submitting.." : "Create Tag"}
                                </Button>
                            </Stack>
                        </Box>
                    </Card>
                </Box>
            </Wrap>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </div>
    );
}

// /tag-creation page
export default function TagCreation() {
    return <TagCreateForm />;
}
